@if (userIsAdmin$ | async) {
  <div class="share-viewer map-control-button-container">
    <button mat-flat-button
      class="map-control-button toggle-button"
      i18n-tmTooltip="@@core.toolbar.share-viewer"
      tmTooltip="Share viewer"
      [class.toggle-button--active]="toolActive"
      (click)="toggle()">
      <mat-icon svgIcon="tools_share"></mat-icon>
    </button>
  </div>
}
